import { DatePicker } from "antd"
import luxonGenerateConfig from "rc-picker/lib/generate/luxon"

const MyDatePicker = DatePicker.generatePicker(luxonGenerateConfig)

export default MyDatePicker
